import React, { useState, useRef, useEffect } from 'react'
import Img from 'app/components/Img'
import FooterButton from 'app/components/FooterButton'
import { _ } from 'app/components/Translator'
import Icon from 'app/components/Icon'
import { motion } from 'framer-motion'
import { InertiaLink } from '@inertiajs/inertia-react'
import route from 'ziggy-js'
import Layout from 'app/components/Layouts/Layout'
import MenuAndReserve from 'app/components/MenuAndReserve'
import MenuAndReserveCatering from 'app/components/MenuAndReserveCatering'
import FooterCatering, { FooterButtonCatering } from 'app/components/Layouts/FooterCatering'
import Header from 'app/components/Header/Main'
import { MainCateringHeader } from 'app/components/Layouts/HeaderCatering'
import { CateringOfferBox } from 'app/components/CateringOfferBox'
import ContentContainer from 'app/components/ContentContainer'
import { isMobile } from 'app/components/hooks/isMobile'
import ServicesSlideshowCatering from 'app/components/Pages/ServicesSlideshowCatering'
import DemandCard from 'app/components/DemandCard'
import Button from 'app/components/Button'





interface Props {
    children?: any
    className?: string,
    title?: string
    onlyReserve?: boolean,
    dark?: boolean
}

export function LayoutCatering({ children, className, title, onlyReserve, dark }: Props) {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        document.title = title || 'Catering';
    }, [title]);

    return (
        <>
            <div id="layoutCatering" className="min-h-screen  font-myriad">
                <div className={` z-10 relative    ${className}`}>
                    <main className=''>
                        {children}
                    </main>
                    <div id={"portal-view"} className="z-70"></div>
                    <div className="bg-transparent relative w-full h-0 md:h-450px" style={{ "pointerEvents": "none" }}></div>
                    <FooterCatering />
                </div>
            </div>
        </>
    )
}



function catering({ children }: Props) {
    const [scrollPosition, setScrollPosition] = useState(0);
    const demandCardRef = useRef<HTMLDivElement>(null);


    function scrollToDemandCard(e?: React.MouseEvent) {
        e?.preventDefault();
        // Scroll to the demand card element
        if (demandCardRef.current) {
            demandCardRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }
    return (
        <LayoutCatering title="Catering New One">
            <MenuAndReserveCatering onRequestDemandCard={scrollToDemandCard}>
                <MainCateringHeader />
                <div className="relative overflow-hidden bg-black w-full" style={{ height: '100vh' }}>
                    <motion.div
                        animate={{
                            scale: (1 + (scrollPosition * 0.0003)), opacity: 1
                        }}
                        initial={{ opacity: 0 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                        className="absolute top-0 left-0 w-full h-full">
                        <video
                            autoPlay
                            loop
                            muted
                            className="w-full mob:hidden h-full object-cover"
                            style={{ filter: 'brightness(0.4)' }}
                        >
                            <source src="/assets/img/catering/video_background.mp4" type="video/mp4" />
                        </video>
                    </motion.div>
                    <div className="absolute w-full top-[60px] left-0 right-0 bottom-0 flex items-center justify-center text-center text-white">
                        <div className="flex flex-col p-16px max-w-3xl items-stretch md:items-center">
                            <div className='mb-40px'>
                                <Img src="/assets/img/catering/catering_big_logo.svg" layout="fill" objectFit="cover" />
                            </div>
                            <div className="text-18 mb-16px font-normal">
                                <_>Zajišťujeme kompletní catering na míru pro firemní i soukromé akce – od slavnostních rautů a tematického občerstvení až po dekorace, personál a doprovodný program, vždy s důrazem na čerstvé suroviny, styl a spolehlivost.</_>
                            </div>
                            <div className="text-18 mb-24px font-semibold">
                                <_>v Café New One i kdekoliv jinde</_>
                            </div>
                            <div className='rounded-2px'>
                                <button className=' bg-brown-light transition hover:bg-opacity-90 duration-300 rounded-[2px] w-full font-semibold px-16px py-12px text-white' value="Nezávazně poptat" onClick={scrollToDemandCard}><_>Nezávazně poptat</_></button>
                            </div>
                        </div>
                    </div>
                </div>
                <ContentContainer p >

                    <ServicesSlideshowCatering />

                </ContentContainer>
                <div className='border-t mt-[64px] border-gray w-full px-0' />
                <ContentContainer  >
                    <div id="demand-card" ref={demandCardRef}>
                        <DemandCard />
                    </div>
                </ContentContainer>
            </MenuAndReserveCatering>
        </LayoutCatering>
    );
}

export default catering